import { getEnv } from './getEnv';

export const isLocalHost = getEnv() === 'local';
